import { useContext, useEffect } from 'react';

import { BreadcrumbProps } from 'components/Breadcrumb';
import { BreadcrumbContext } from 'contexts';

export const useBreadcrumbContext = () => useContext(BreadcrumbContext);

export const useBreadcrumb = (breadcrumbData: BreadcrumbProps) => {
  const { setBreadcrumbData } = useBreadcrumbContext();
  useEffect(() => {
    setBreadcrumbData(breadcrumbData);
    return () => {
      setBreadcrumbData(undefined);
    };
  }, [breadcrumbData, setBreadcrumbData]);
};
